import { AddressesApi, HttpClient } from '../../../api'
import { Context, PaginatedResult } from '../../../common'
import { AddressSuggesterService, AddressSuggestion, AddressSuggestionSearchOptions } from './suggester'

export class RemoteAddressSuggesterService implements AddressSuggesterService {
  private api: AddressesApi

  constructor(httpClient: HttpClient) {
    this.api = new AddressesApi(httpClient, undefined, '')
  }

  async suggest(ctx: Context, opts: AddressSuggestionSearchOptions): Promise<PaginatedResult<AddressSuggestion>> {
    const response = await this.api.addressesSuggest(ctx, {
      level: opts.level,
      search: opts.search,
      aFrom: opts.paging?.from,
      count: opts.paging?.count,
      locality: opts.otherFields?.locality,
      street: opts.otherFields?.street,
      municipalEntityId: opts.municipalEntityId,
    })
    return response.body
  }
}
